import React, {Component} from 'react';
import {RouteConstants} from "../../components/route/services/RouteConstants";
import CardWidget from "../../components/card-widget/CardWidget";
import CardWidgetContent from "../../components/card-widget/CardWidgetContent";
import { ActivityMonitorConstants } from "../../components/activity-monitor/ActivityMonitorConstants";

class Logout extends Component {
  constructor(props) {
    super(props);
    this.logoutType = 'normal';
  }

  componentWillMount() {
    if (window.sessionStorage.getItem('myblock.logouttype') === 'auto') {
      this.logoutType = 'auto';
    }
    window.sessionStorage.removeItem('myblock.logouttype')
  }

  goToLogin = () => {
    this.props.history.push(RouteConstants.LOGIN);
  };

  getLogoutCardContent = () => {
    var content = []

    if (this.logoutType === 'auto') {
      var totalTime = Math.floor(ActivityMonitorConstants.TIME_TO_WARNING_MINS + ActivityMonitorConstants.TIME_TO_SIGNOUT_MINS);
      content.push(<CardWidgetContent contentText="logout.subtitle" key='cw-sub' className="hrb-card-widget-content-activity logout-card-widget-top-margin"/>);
      content.push(<CardWidgetContent contentText="logout.you_have_been_automatically_signed_out" key='cw-content'
                      className="hrb-card-widget-content-activity logout-card-widget-bottom-margin" params={{timeoutLength: totalTime}} />);
    } else {
      content.push(<CardWidgetContent contentText="logout.you_have_been_signed_out" key='cw-content' className="hrb-card-widget-content-activity"/>);
    }
        
    return content;
  };

  render() {
    return (
        <CardWidget getCardContent={this.getLogoutCardContent}
                    submitButtonAction={this.goToLogin}
                    submitButtonText={this.logoutType === 'auto' ? "logout.return_to_sign_in" : "logout.sign_in"}/>
    )
  };
}

export default Logout;